'use strict';
import Labels from "./labels";
import Config from "./config";

let utils = {
  getIsoDate(date) {
    if (!date || typeof (date) !== "object") return "";
    return `${date.getFullYear()}-${(this.twoDigits(date.getMonth() + 1))}-${this.twoDigits(date.getDate())}`
  },
  twoDigits(x) {
    if (x < 10) return `0${x}`;
    else return `${x}`;
  },
  processFacetChecked(facets, opt) {
    if (!facets || !opt || !opt.sender) return;
    if (opt.checked && opt.sender.value) {
      facets.push(opt.sender.value);
    }
    else {
      var pos = facets.indexOf(opt.sender.value);
      if (pos != -1) facets.splice(pos, 1);
    }
    return facets;
  },
  showStatusMessage (msg, color, duration) {
    if (!msg) return;
    color = color || "green";
    duration = duration | 5000;
    let messageBox = document.createElement("div");
    messageBox.classList.add("assw-messagebox");
    messageBox.classList.add(color);
    messageBox.innerHTML = msg;
    document.body.appendChild(messageBox);
    setTimeout(() => {
      if (messageBox) {
        messageBox.style.opacity = '0';
        setTimeout(() => {
          messageBox.remove();
        }, 500);
      }
    }, duration);
  },
  validateEmail(email) {
    //email = email.trim();
    if (!email) return true;  //empty is ok here
    if (email.indexOf(" ") !== -1) return false;  //we should not have spaces in the email
    let isValid = true;
    email.split(";").map((e) => {
      if (!this.validateSingleEmail(e)) isValid = false;
    })
    return isValid;

    /*let regex = /^(([\w\.\-]+)\@([\w\-]+\.)+([a-zA-Z0-9]{2,6})*[;]?)+$/;
    return regex.test(email);*/
  },
  validateSingleEmail(email) {
    if (!email) return false;
    let regex = /^([\w\.\-]+)\@([\w\-]+\.)+([a-zA-Z0-9]{2,6})*$/;
    return regex.test(email);
  }
};

export default utils;